export const RENAVAM_REGEX = /^\d{9,11}$/;

export default function renavam(value = '') {
  if (['', undefined, null].includes(value)) {
    return false;
  }

  if (RENAVAM_REGEX.test(value)) {
    return false;
  }

  return true;
}

renavam.message = function message(value, options = {}) {
  return options.message || 'não é um renavam válido';
};
